import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '@crest/module-projects/contracts/detail-host';
import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { procurementModuleManifest } from '../procurement.module.js';
import { procurementSettingRegistrations } from '../settings/procurement-setting-definitions.js';
export const procurementWebModuleContribution = {
    moduleId: 'procurement',
    manifest: procurementModuleManifest,
    settingRegistrations: procurementSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: 'procurement.web.projects.order-summary',
            moduleId: 'procurement',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'procurement.orders.read',
            settingCondition: {
                key: 'procurement.orders.display',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 50,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Procurement',
                fallbackDescription: 'Review Project orders, suppliers, and subcontract activity.',
                defaultSize: 'standard',
                supportedSizes: ['compact', 'standard', 'wide'],
            }),
            load: () => import('./procurement-project-order-summary.panel.js'),
        }, {
            id: 'procurement.web.projects.supplier-operations-summary',
            moduleId: 'procurement',
            slot: projectsProjectDetailHostSlots.sidebar,
            contractVersion: projectsProjectDetailHostCapability,
            requiredPermission: 'procurement.subcontracts.read',
            settingCondition: {
                key: 'procurement.supplier-operations.display',
                property: 'projectPanelEnabled',
                equals: true,
            },
            priority: 51,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            load: () => import('./procurement-project-supplier-operations-summary.panel.js'),
        }],
    routes: [{
            id: 'procurement.web.orders',
            moduleId: 'procurement',
            path: '/procurement/orders',
            requiredPermission: 'procurement.orders.read',
            navigation: {
                id: 'procurement.navigation.orders',
                fallbackLabel: 'Procurement',
                labelConfigurationKey: 'procurement.copy.orders',
                labelValueProperty: 'navigationLabel',
                priority: 70,
            },
            load: () => import('./procurement-orders.page.js'),
        }, {
            id: 'procurement.web.supplier-operations',
            moduleId: 'procurement',
            path: '/procurement/supplier-operations',
            requiredPermission: 'procurement.subcontracts.read',
            navigation: {
                id: 'procurement.navigation.supplier-operations',
                fallbackLabel: 'Supplier operations',
                labelConfigurationKey: 'procurement.copy.supplier-operations',
                labelValueProperty: 'navigationLabel',
                priority: 71,
            },
            load: () => import('./procurement-supplier-operations.page.js'),
        }],
};
export default procurementWebModuleContribution;
//# sourceMappingURL=procurement-web.module-contribution.js.map